<div style="width:100%;height:100px;border:1px solid #002F87;background-color:#9ad59a;">

    <!-- <div style="width:100%;margin-top:0px;height:10px;">
        <div class="d-flex flex-row-reverse" style="width:100%;">
            <mat-icon aria-hidden="false" aria-label="Close" fontIcon="close" style="color:black;"></mat-icon>
        </div>
    </div> -->
    <p></p><p></p>
    <div style="margin-top:15px;height:10px;">
        <span class="d-flex justify-content-center align-items-center">
           <div style="margin-top:05px;">
            <span class="ace>-secondary-text-14pt-semi" style="font-size:36px;font-weight: bold !important;color: black;">{{displayText}}</span>
            </div>
        </span>
    </div>
</div>
